import {
  SET_LANGUAGE
} from './mutation-types'

export function setLanguage ({ commit }, language) {
  commit(SET_LANGUAGE, language)
}



// WEBPACK FOOTER //
// ./src/vuex/modules/language/actions.js